import axios from 'axios';
import { removeAuthToken } from './auth';

// When the login session is gone/expired, the server tags the 401/403 with
// code "AUTH_EXPIRED". Instead of letting the page surface a confusing generic
// error (e.g. "Failed to load subscriptions"), bounce the user to the login page.
let redirecting = false;

export function setupApiInterceptors() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const code = error?.response?.data?.code;
      // Only react to genuine auth-session failures (the code is set by the user
      // auth middleware) — NOT to legitimate resource 403s, which carry no code.
      const authExpired = code === 'AUTH_EXPIRED' && (status === 401 || status === 403);
      if (authExpired && !redirecting) {
        const path = window.location.pathname || '';
        const onAuthPage = /^\/(login|register|verify-email|reset-password|forgot-password)/.test(path);
        if (!onAuthPage) {
          redirecting = true;
          removeAuthToken();
          window.location.assign('/login?session=expired');
        }
      }
      return Promise.reject(error);
    }
  );
}
